/**
 * Scrolls the window so the element's top edge sits just below the sticky header.
 * Used after pagination so the list header/table top comes back into view.
 */
export const scrollToElementTop = (element: HTMLElement | null) => {
  if (!element) return

  const headerHeight = document.querySelector('header')?.getBoundingClientRect().height ?? 0
  const top = element.getBoundingClientRect().top + window.scrollY - headerHeight - 16

  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
}
